// utils/loadCountries.js or directly in your component
exports.loadAllCountries = () => {
  const context = require.context('../data/channels/raw/countries', false, /\.json$/);
  const countries = {};
  context.keys().forEach((key) => {
    const countryCode = key.replace('./', '').replace('.json', '');
    const countryData = context(key);
    countries[countryCode] = countryData;
  });
  return countries;
  };
exports.loadAllCategories = () => {
  const context = require.context('../data/channels/raw/categories', false, /\.json$/);
  const categories = {};
  context.keys().forEach((key) => {
    const categoryName = key.replace('./', '').replace('.json', '');
    const categoryData = context(key);
    categories[categoryName] = categoryData;
  });
  return categories;
}
  